import { render, staticRenderFns } from "./Taskview.vue?vue&type=template&id=51c5b6bb&scoped=true&"
import script from "./Taskview.vue?vue&type=script&lang=js&"
export * from "./Taskview.vue?vue&type=script&lang=js&"
import style0 from "./Taskview.vue?vue&type=style&index=0&id=51c5b6bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c5b6bb",
  null
  
)

export default component.exports